import React from 'react';
import { Link } from 'react-router-dom';
import abimg from '../../images/about.jpg';
import abimg4 from '../../images/shape/shape2.png';
import { FaChild} from "react-icons/fa";
import { FcLandscape } from "react-icons/fc";

const About2 = () => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    };

    return (
        <div className="about-area section-padding">
            <div className="container">
                <div className="row">
                    {/* Left Side - Static Image */}
                    <div className="col-lg-5 col-md-12 grid col-12">
                        <div className="image-area">
                            <img
                                src={abimg}
                                alt="About Nardhanamala Centre for Performing Arts Foundation"
                                className="img-fluid rounded shadow"
                                style={{ borderRadius: '12px', objectFit: 'cover', width: '100%' }}
                            />
                        </div>
                    </div>

                    {/* Right Side - About Text */}
                    <div className="col-lg-7 grid col-md-12 col-12">
                        <div className="about-text">
                            <div className="section-title">
                                <div className="thumb-text">
                                    <span>ABOUT US</span>
                                </div>
                                <h2>
                                    Nardhanamala Centre for Performing Arts Foundation — <span>Arts Accessible, Structured and Beneficial to All Ages</span>
                                </h2>
                            </div>

                            <p>
                                Founded in 1992 and formally established as Nardhanamala Centre for Performing Arts Foundation in 2018, our institution is backed by decades of teaching experience. We are registered under the Ministry of Art and Culture and operate as an NGO trust as well as a private limited entity, ensuring both social impact and operational sustainability.
                            </p>

                            <p>
                                <strong>Nardhanamala NGO / Trust</strong> TN/2025/0607013<br />
                                <strong>Nardhanamala Private Limited Company</strong> 179423
                            </p>


                            {/* <div className="ab-icon-area">
                                <div className="about-icon-wrap">
                                    <div className="about-icon-item">
                                        <div className="ab-icon" style={{ width: '80px', height: '80px' }}>
                                            <FaChild style={{ width: '40px', height: '40px' }} />
                                        </div>
                                        <div className="ab-text">
                                            <h2>
                                                <Link onClick={ClickHandler} to="/case-single">
                                                    Dance & Music Education
                                                </Link>
                                            </h2>
                                        </div>
                                    </div>

                                    <div className="about-icon-item">
                                        <div className="ab-icon ab-icon2" style={{ width: '80px', height: '80px' }}>
                                            <FcLandscape style={{ width: '42px', height: '42px' }} />
                                        </div>
                                        <div className="ab-text">
                                            <h2>
                                                <Link onClick={ClickHandler} to="/case-single">
                                                    Rural & Tribal Arts Programs
                                                </Link>
                                            </h2>
                                        </div>
                                    </div>
                                </div>
                            </div> */}

                        </div>
                    </div>
                </div>
            </div>

            <div className="ab-shape">
                <img src={abimg4} alt="Decorative background shape" />
            </div>
        </div>
    );
};

export default About2;
